<template>
	<Modal v-model="show" :hasCloseIcon="true" :width="800">
		<div slot="header">选择科目</div>
		<div class="subject-select-dialog">
			<Tabs :datas="tabDatas" v-model="selectedTab" @change="changeTab"></Tabs>
			<div class="search-box padding-top padding-bottom">
				<Search v-model="searchText" placeholder="输入名称或编码搜索" @on-search="doSearch"
						v-width="300"></Search>
			</div>
			<div class="subject-tree-container">
				<table class="subject-table">
					<thead>
						<tr>
							<th width="150">科目编码</th>
							<th>科目名称</th>
							<th width="80">方向</th>
						</tr>
					</thead>
					<tbody v-if="filteredDatas.length > 0">
						<tr v-for="data in filteredDatas" :key="data.id" 
							@click="rowClick(data)"
							:class="{'selected-row': selectedRow && selectedRow.id === data.id}">
							<td>
								<span :style="{paddingLeft:(data.level-1)*15+'px'}">{{data.code}}</span>
							</td>
							<td>{{data.name}}</td>
							<td class="text-center">{{data.balanceDirection}}</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td colspan="3" class="text-center padding">暂无数据</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div slot="footer">
			<Button color="primary" @click="confirm" :disabled="!selectedRow">确定</Button>
			<Button @click="close">取消</Button>
		</div>
	</Modal>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		name: "SubjectSelectDialog",
		props: {
			value: Boolean,
		},
		data() {
			return {
				show: false,
				loading: false,
				selectedTab: '资产',
				allDatas: [],
				filteredDatas: [],
				searchText: '',
				selectedRow: null
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			tabDatas() {
				let tabs = [
					{title: '资产', key: '资产'},
					{title: '负债', key: '负债'}
				];
				if (this.currentAccountSets && this.currentAccountSets.accountingStandards !== 0) {
					tabs.push({title: '共同', key: '共同'});
				}
				tabs.push(
					{title: '权益', key: '权益'},
					{title: '成本', key: '成本'},
					{title: '损益', key: '损益'}
				);
				return tabs;
			}
		},
		watch: {
			value(val) {
				this.show = val;
				if (val) {
					this.loadList();
				}
			},
			show(val) {
				this.$emit('input', val);
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.setting.subject.list(this.selectedTab).then(({data}) => {
					this.allDatas = data || [];
					this.doSearch();
					this.loading = false;
				});
			},
			changeTab(data) {
				this.selectedTab = data.key;
				this.loadList();
			},
			doSearch() {
				if (!this.searchText) {
					this.filteredDatas = this.allDatas;
				} else {
					let search = this.searchText.toLowerCase();
					this.filteredDatas = this.allDatas.filter(item => 
						item.code.includes(search) || item.name.includes(search) || (item.mnemonicCode && item.mnemonicCode.toLowerCase().includes(search))
					);
				}
			},
			rowClick(data) {
				this.selectedRow = data;
			},
			confirm() {
				if (this.selectedRow) {
					this.$emit('confirm', this.selectedRow);
					this.show = false;
				}
			},
			close() {
				this.show = false;
			}
		}
	}
</script>

<style scoped lang="less">
	.subject-select-dialog {
		.subject-tree-container {
			height: 450px;
			overflow-y: auto;
			border: 1px solid #eee;
			margin-top: 10px;
		}
		.search-box {
			padding: 0;
		}
		.subject-table {
			width: 100%;
			border-collapse: collapse;
			th {
				background: #f8f9fa;
				padding: 10px;
				text-align: left;
				border-bottom: 2px solid #eee;
				position: sticky;
				top: 0;
				z-index: 10;
			}
			td {
				padding: 8px 10px;
				border-bottom: 1px solid #f0f0f0;
			}
			tr {
				cursor: pointer;
				&:hover {
					background: #f5f5f5;
				}
				&.selected-row {
					background-color: #e3f2fd !important;
					color: #2196f3;
					font-weight: bold;
				}
			}
		}
	}
</style>
